module.exports = __webpack_public_path__ + "static/media/bfile-classic_car.5650d3d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-classic_car.svg
// module id = 100
// module chunks = 0